<template>
  <div class="box">
    <el-collapse @change="handleChange" v-model="activeNames">
      <el-collapse-item name="1">
        <template slot="title">
          <span class="title-icon"></span>
          {{infoName}}
        </template>
        <div class="slot-box">
          <slot name="content"></slot>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
  export default {
    name: "Index",
    props: {
      infoName: {
        type: String
      },
      infoNameTips: {
        type: String,
        default: "xxxxx"
      }
    },
    data() {
      return {
        activeNames: ["1"],
        icon: "el-icon-arrow-up"
      };
    },
    methods: {
      handleChange(val) {
        val.length > 0
          ? (this.icon = "el-icon-arrow-up")
          : (this.icon = "el-icon-arrow-down");
      }
    }
  };
</script>
<style lang="scss" scoped>
  .box {
    margin-top: 20px;
    .title-icon {
      display: inline-block;
      width: 4px;
      height: 24px;
      background-color: #1369a8;
      margin-right: 14px;
    }
    /deep/.el-collapse-item__header {
      padding:0 20px 0 20px;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      height: 40px;
      line-height: 40px;
      background-color: #e7f0f7;
    }
    /deep/ .el-collapse-item__wrap {
      border-bottom: none;
    }
  }
</style>
